let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6Zrpq")).then(() => parcelRequire('6kz4R'));